var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup1414(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 214.798,
    height: 236.963,
    viewBox: "0 0 214.798 236.963",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1414",
    "data-name": "Group 1414",
    transform: "translate(-100.601 -277.361)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12501",
    "data-name": "Path 12501",
    d: "M10.437-2.793H4.6L3.633,0H.546L5.817-14.679H9.24L14.511,0H11.4Zm-.8-2.352L7.518-11.277,5.4-5.145Zm6.09-.672a6.526,6.526,0,0,1,.735-3.16,5.254,5.254,0,0,1,2.037-2.1,5.894,5.894,0,0,1,2.982-.746,5.733,5.733,0,0,1,3.58,1.082,5.261,5.261,0,0,1,1.9,3.034H23.793a2.319,2.319,0,0,0-.851-1.187,2.469,2.469,0,0,0-1.48-.431,2.425,2.425,0,0,0-2,.913,4.043,4.043,0,0,0-.735,2.594,4.006,4.006,0,0,0,.735,2.573,2.425,2.425,0,0,0,2,.914,2.23,2.23,0,0,0,2.331-1.6h3.171a5.366,5.366,0,0,1-1.911,3A5.632,5.632,0,0,1,21.483.189,5.894,5.894,0,0,1,18.5-.557a5.254,5.254,0,0,1-2.037-2.1A6.526,6.526,0,0,1,15.729-5.817Zm12.642,0a6.526,6.526,0,0,1,.735-3.16,5.254,5.254,0,0,1,2.037-2.1,5.894,5.894,0,0,1,2.982-.746,5.733,5.733,0,0,1,3.581,1.082,5.261,5.261,0,0,1,1.9,3.034H36.435a2.319,2.319,0,0,0-.85-1.187,2.469,2.469,0,0,0-1.48-.431,2.425,2.425,0,0,0-2,.913,4.043,4.043,0,0,0-.735,2.594,4.006,4.006,0,0,0,.735,2.573,2.425,2.425,0,0,0,2,.914,2.23,2.23,0,0,0,2.331-1.6h3.171a5.366,5.366,0,0,1-1.911,3A5.632,5.632,0,0,1,34.125.189a5.894,5.894,0,0,1-2.982-.746,5.254,5.254,0,0,1-2.037-2.1A6.526,6.526,0,0,1,28.371-5.817ZM46.935.189a6.128,6.128,0,0,1-3.024-.746A5.368,5.368,0,0,1,41.8-2.667a6.324,6.324,0,0,1-.766-3.15,6.19,6.19,0,0,1,.787-3.15,5.472,5.472,0,0,1,2.153-2.111,6.247,6.247,0,0,1,3.045-.746,6.247,6.247,0,0,1,3.045.746,5.472,5.472,0,0,1,2.153,2.111A6.19,6.19,0,0,1,53-5.817a6.063,6.063,0,0,1-.809,3.15A5.6,5.6,0,0,1,50.012-.557,6.351,6.351,0,0,1,46.935.189Zm0-2.562a3.058,3.058,0,0,0,1.5-.388A2.823,2.823,0,0,0,49.56-3.927a3.928,3.928,0,0,0,.42-1.89,3.5,3.5,0,0,0-.872-2.552,2.865,2.865,0,0,0-2.131-.892,2.8,2.8,0,0,0-2.111.892,3.555,3.555,0,0,0-.851,2.552,3.611,3.611,0,0,0,.83,2.552A2.731,2.731,0,0,0,46.935-2.373ZM66.15-11.634V0H63.189V-1.47a3.882,3.882,0,0,1-1.48,1.187,4.6,4.6,0,0,1-1.985.431,4.929,4.929,0,0,1-2.415-.578,4.071,4.071,0,0,1-1.648-1.7,5.621,5.621,0,0,1-.6-2.678v-6.825H58v6.405A3.017,3.017,0,0,0,58.695-3.1a2.454,2.454,0,0,0,1.89.746A2.481,2.481,0,0,0,62.5-3.1a3.017,3.017,0,0,0,.693-2.132v-6.405ZM75.5-11.8a4.484,4.484,0,0,1,3.36,1.313,5.025,5.025,0,0,1,1.281,3.665V0H77.2V-6.426A3.017,3.017,0,0,0,76.5-8.558a2.454,2.454,0,0,0-1.89-.745,2.515,2.515,0,0,0-1.922.745,2.988,2.988,0,0,0-.7,2.132V0h-2.94V-11.634h2.94v1.449a4.062,4.062,0,0,1,1.5-1.187A4.645,4.645,0,0,1,75.5-11.8ZM86.352-9.219v5.628a1.112,1.112,0,0,0,.284.851,1.393,1.393,0,0,0,.955.262h1.365V0H87.108q-3.717,0-3.717-3.612V-9.219H82v-2.415h1.386v-2.877h2.961v2.877h2.6v2.415Zm12.663-3.066V-8.61h4.935v2.331H99.015v3.885h5.565V0H96.075V-14.679h8.505v2.394ZM113.673,0l-2.394-3.612L109.158,0h-3.15l3.8-5.838-3.843-5.8h3.318l2.373,3.591,2.142-3.591h3.15l-3.822,5.8L116.991,0Zm7.854-9.954a4.464,4.464,0,0,1,1.564-1.333,4.742,4.742,0,0,1,2.279-.536,5.088,5.088,0,0,1,2.7.735A5.171,5.171,0,0,1,129.98-9a6.717,6.717,0,0,1,.7,3.14,6.845,6.845,0,0,1-.7,3.161,5.291,5.291,0,0,1-1.911,2.131,4.981,4.981,0,0,1-2.7.756,4.694,4.694,0,0,1-2.257-.525,4.843,4.843,0,0,1-1.586-1.323v7.2h-2.94V-11.634h2.94Zm6.153,4.1a3.651,3.651,0,0,0-.43-1.816,2.981,2.981,0,0,0-1.134-1.166,3.035,3.035,0,0,0-1.522-.4,2.936,2.936,0,0,0-1.5.41,3.039,3.039,0,0,0-1.134,1.187,3.711,3.711,0,0,0-.431,1.827,3.711,3.711,0,0,0,.431,1.827A3.039,3.039,0,0,0,123.091-2.8a2.936,2.936,0,0,0,1.5.41,2.918,2.918,0,0,0,1.522-.42,3.118,3.118,0,0,0,1.134-1.2A3.756,3.756,0,0,0,127.68-5.859Zm6.636-7.161a1.791,1.791,0,0,1-1.292-.493,1.633,1.633,0,0,1-.514-1.229,1.633,1.633,0,0,1,.514-1.228,1.791,1.791,0,0,1,1.292-.494,1.791,1.791,0,0,1,1.292.494,1.633,1.633,0,0,1,.514,1.228,1.633,1.633,0,0,1-.514,1.229A1.791,1.791,0,0,1,134.316-13.02Zm1.449,1.386V0h-2.94V-11.634ZM141.6-9.828a4.133,4.133,0,0,1,1.481-1.449,4.118,4.118,0,0,1,2.089-.525v3.087H144.4a2.978,2.978,0,0,0-2.09.651,3,3,0,0,0-.7,2.268V0h-2.94V-11.634h2.94Zm16.359,3.759a6.938,6.938,0,0,1-.084,1.134h-8.505a2.892,2.892,0,0,0,.882,1.974,2.72,2.72,0,0,0,1.911.714A2.4,2.4,0,0,0,154.5-3.654h3.171a5.3,5.3,0,0,1-1.932,2.762A5.64,5.64,0,0,1,152.229.189a6.069,6.069,0,0,1-3.014-.746,5.247,5.247,0,0,1-2.079-2.111,6.467,6.467,0,0,1-.746-3.15,6.587,6.587,0,0,1,.735-3.171,5.128,5.128,0,0,1,2.058-2.1,6.165,6.165,0,0,1,3.045-.735,6.116,6.116,0,0,1,2.971.714,5.025,5.025,0,0,1,2.037,2.027A6.133,6.133,0,0,1,157.962-6.069Zm-3.045-.84a2.331,2.331,0,0,0-.819-1.816,2.9,2.9,0,0,0-1.953-.682,2.669,2.669,0,0,0-1.838.661,2.909,2.909,0,0,0-.913,1.838Zm4.431,1.05a6.733,6.733,0,0,1,.7-3.129,5.132,5.132,0,0,1,1.921-2.1,5.142,5.142,0,0,1,2.709-.735,4.941,4.941,0,0,1,2.163.494,4.325,4.325,0,0,1,1.638,1.313V-15.54h2.982V0h-2.982V-1.722A3.984,3.984,0,0,1,166.95-.336a4.8,4.8,0,0,1-2.289.525,5,5,0,0,1-2.688-.756A5.265,5.265,0,0,1,160.051-2.7,6.845,6.845,0,0,1,159.348-5.859Zm9.156.042a3.771,3.771,0,0,0-.42-1.838,2.961,2.961,0,0,0-1.134-1.176,3.031,3.031,0,0,0-1.533-.41,2.978,2.978,0,0,0-1.512.4,3,3,0,0,0-1.124,1.166,3.651,3.651,0,0,0-.43,1.816,3.771,3.771,0,0,0,.43,1.838,3.1,3.1,0,0,0,1.134,1.207,2.881,2.881,0,0,0,1.5.42,3.031,3.031,0,0,0,1.533-.41,2.961,2.961,0,0,0,1.134-1.176A3.771,3.771,0,0,0,168.5-5.817Z",
    transform: "translate(121.5 508.78)",
    fill: "#4381de"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1413",
    "data-name": "Group 1413",
    transform: "translate(22.601 99)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clock_2",
    "data-name": "Clock 2",
    transform: "translate(197.376 246.906)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_101",
    "data-name": "Group 101",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_91",
    "data-name": "Group 91"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16",
    "data-name": "Rectangle 16",
    width: 95.422,
    height: 6.819,
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_90",
    "data-name": "Group 90",
    transform: "translate(4.714 6.819)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17",
    "data-name": "Rectangle 17",
    width: 85.994,
    height: 4.273,
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M366.015,250.486l-85.994.941V248.82h85.994Z",
    transform: "translate(-280.021 -248.82)",
    opacity: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_93",
    "data-name": "Group 93",
    transform: "translate(0 119.142)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18",
    "data-name": "Rectangle 18",
    width: 95.422,
    height: 6.819,
    transform: "translate(95.422 11.093) rotate(180)",
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_92",
    "data-name": "Group 92",
    transform: "translate(4.714)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19",
    "data-name": "Rectangle 19",
    width: 85.994,
    height: 4.273,
    transform: "translate(85.994 4.273) rotate(180)",
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M280.021,435.591l85.994-.941v2.607H280.021Z",
    transform: "translate(-280.021 -432.984)",
    opacity: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_94",
    "data-name": "Group 94",
    transform: "translate(10.471 10.938)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M358.841,336.675c3.444,4.789,4.982,27.162,4.982,27.162H289.677s1.534-22.373,4.982-27.162c5.5-7.639,28.807-24.066,28.807-27.834v-1.4c-.178-3.848-23.332-20.176-28.807-27.787-3.444-4.789-4.982-23.869-4.982-23.869h74.146s-1.534,19.08-4.982,23.869c-5.5,7.639-28.807,24.066-28.807,27.834v1.4C330.212,312.736,353.366,329.064,358.841,336.675Z",
    transform: "translate(-289.511 -255.631)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M363.883,363.893H289.409l.012-.164c.062-.915,1.576-22.471,5.01-27.24,2.6-3.609,9.071-9.1,15.33-14.411,6.611-5.61,13.448-11.409,13.448-13.334v-1.4c-.091-1.956-6.574-7.455-13.439-13.277-6.263-5.315-12.741-10.809-15.339-14.421-3.429-4.769-4.947-23.165-5.01-23.945l-.013-.166h74.477l-.013.166c-.063.78-1.576,19.176-5.01,23.946-2.6,3.609-9.071,9.1-15.331,14.411-6.612,5.609-13.448,11.409-13.448,13.333v1.4c.091,1.956,6.574,7.455,13.439,13.277,6.264,5.314,12.742,10.808,15.341,14.421h0c3.43,4.769,4.947,26.324,5.01,27.24Zm-74.145-.307h73.816c-.15-2.046-1.717-22.434-4.942-26.918h0c-2.576-3.581-9.039-9.064-15.29-14.365-7.217-6.122-13.449-11.408-13.546-13.5v-1.41c0-2.066,6.282-7.4,13.556-13.567,6.246-5.3,12.7-10.778,15.28-14.357,3.214-4.464,4.778-21.74,4.94-23.625H289.74c.163,1.885,1.729,19.162,4.939,23.626,2.576,3.581,9.039,9.063,15.29,14.365,7.216,6.121,13.448,11.408,13.546,13.5v1.409c0,2.066-6.283,7.4-13.556,13.567-6.246,5.3-12.7,10.778-15.28,14.357C291.45,341.152,289.887,361.54,289.738,363.586Z",
    transform: "translate(-289.407 -255.534)",
    fill: "#c7c7c7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M357.927,335.024c3.24,4.506,4.688,28.745,4.688,28.745H297.079s1.443-24.239,4.688-28.745c5.174-7.189,27.107-22.646,27.107-26.192v-1.319c-.168-3.621-21.955-18.985-27.107-26.147-3.241-4.506-4.688-25.753-4.688-25.753h65.536s-1.443,21.247-4.688,25.753c-5.175,7.189-27.108,22.646-27.108,26.191v1.319C330.988,312.5,352.775,327.862,357.927,335.024Z",
    transform: "translate(-281.902 -244.627)",
    fill: "#ebebeb",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_97",
    "data-name": "Group 97",
    transform: "translate(15.487 87.181)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_95",
    "data-name": "Group 95"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    d: "M362.03,411.792H297.584s26.281-31.963,32.223-31.963S362.03,411.792,362.03,411.792Z",
    transform: "translate(-297.584 -379.829)",
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M362.03,411.792H297.584s26.281-31.963,32.223-31.963S362.03,411.792,362.03,411.792Z",
    transform: "translate(-297.584 -379.829)",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_96",
    "data-name": "Group 96",
    transform: "translate(7.26 7.483)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M374.639,422.9a.455.455,0,1,1-.455-.455A.455.455,0,0,1,374.639,422.9Z",
    transform: "translate(-334.281 -403.785)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M321.683,413.524a.455.455,0,1,1-.455-.455A.455.455,0,0,1,321.683,413.524Z",
    transform: "translate(-313.809 -400.162)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M376.509,419.951a.339.339,0,1,1-.339-.339A.339.339,0,0,1,376.509,419.951Z",
    transform: "translate(-335.094 -402.692)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M369.453,399.89a.339.339,0,1,1-.339-.339A.339.339,0,0,1,369.453,399.89Z",
    transform: "translate(-332.366 -394.936)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M310.1,425.2a.339.339,0,1,1-.339-.339A.339.339,0,0,1,310.1,425.2Z",
    transform: "translate(-309.42 -404.721)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M342.294,396.064a.339.339,0,1,1-.339-.339A.339.339,0,0,1,342.294,396.064Z",
    transform: "translate(-321.867 -393.457)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M341.32,392.262a.235.235,0,1,1-.235-.234A.235.235,0,0,1,341.32,392.262Z",
    transform: "translate(-321.571 -392.028)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M349.31,419.081a.235.235,0,1,1-.234-.234A.234.234,0,0,1,349.31,419.081Z",
    transform: "translate(-324.66 -402.396)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    d: "M325.551,421.632a.235.235,0,1,1-.234-.235A.234.234,0,0,1,325.551,421.632Z",
    transform: "translate(-315.475 -403.382)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    "data-name": "Path 138",
    d: "M373.816,405.734a.235.235,0,1,1-.235-.234A.235.235,0,0,1,373.816,405.734Z",
    transform: "translate(-334.134 -397.236)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 0.235,
    cy: 0.235,
    rx: 0.235,
    ry: 0.235,
    transform: "translate(45.612 20.01)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_100",
    "data-name": "Group 100",
    transform: "translate(39.745 53.144)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_98",
    "data-name": "Group 98"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    d: "M345.638,355.8c0,1.294,1.411,3.828,1.411,3.828h-3.441s1.411-2.533,1.411-3.828V340.374c0-8.2-.669-9.33-1.313-10.311a41,41,0,0,1-6.576-5.723h16.4a41,41,0,0,1-6.582,5.729l-.006.006c-.638.975-1.3,2.141-1.3,10.3Z",
    transform: "translate(-337.13 -324.34)",
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    d: "M345.638,355.8c0,1.294,1.411,3.828,1.411,3.828h-3.441s1.411-2.533,1.411-3.828V340.374c0-8.2-.669-9.33-1.313-10.311a41,41,0,0,1-6.576-5.723h16.4a41,41,0,0,1-6.582,5.729l-.006.006c-.638.975-1.3,2.141-1.3,10.3Z",
    transform: "translate(-337.13 -324.34)",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_99",
    "data-name": "Group 99",
    transform: "translate(4.479 1.186)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    "data-name": "Path 141",
    d: "M346.982,327.379a.339.339,0,1,1,.339.339A.338.338,0,0,1,346.982,327.379Z",
    transform: "translate(-345.418 -326.57)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    d: "M344.432,329.367a.235.235,0,1,1,.234.234A.235.235,0,0,1,344.432,329.367Z",
    transform: "translate(-344.432 -327.379)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    d: "M358.681,326.509a.235.235,0,1,1,.234.235A.235.235,0,0,1,358.681,326.509Z",
    transform: "translate(-349.941 -326.274)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    d: "M302.128,400.109a86.485,86.485,0,0,1,.155-12.717c.175-2.116.413-4.22.8-6.366.115-.555.2-1.07.367-1.656l.119-.433.06-.217c.025-.078.07-.185.1-.275a7,7,0,0,1,.479-.972,21.912,21.912,0,0,1,2.057-2.763,80.474,80.474,0,0,1,9.239-8.84,86.068,86.068,0,0,1,10.31-7.441c-2.644,3.353-5.477,6.466-8.322,9.544s-5.772,6.077-8.432,9.131a20.168,20.168,0,0,0-1.749,2.252,3.992,3.992,0,0,0-.243.427.733.733,0,0,0-.045.089l-.051.161-.1.323c-.144.417-.25.938-.387,1.4-.482,1.967-.9,4.015-1.348,6.056C304.251,391.9,303.347,396.018,302.128,400.109Z",
    transform: "translate(-283.789 -284.375)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    d: "M325.472,299.543a113.613,113.613,0,0,1-9.848-7.791q-4.7-4.117-9.124-8.522l-.552-.551-.274-.277c-.1-.1-.153-.148-.325-.338a7.387,7.387,0,0,1-1.114-1.745,21.484,21.484,0,0,1-1.148-3.19,50.644,50.644,0,0,1-1.278-6.265,66.918,66.918,0,0,1-.674-12.6c1.334,4.009,2.4,8.028,3.524,11.99.57,1.973,1.119,3.949,1.776,5.823a20.52,20.52,0,0,0,1.069,2.633,4.074,4.074,0,0,0,.551.879l1.05,1.043q4.408,4.408,8.546,9.088A113.764,113.764,0,0,1,325.472,299.543Z",
    transform: "translate(-283.444 -245.653)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Character",
    transform: "translate(78 178.361)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71",
    "data-name": "Group 71",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33",
    transform: "translate(11.333 151.119)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    "data-name": "Group 27",
    transform: "translate(26.115 0.022)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    "data-name": "Group 26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M186.284,419.726H128.022c-.48-1.876-.945-3.721-1.41-5.538-.531-2.089-1.056-4.127-1.557-6.113-.111-.444-.229-.886-.34-1.322q-.576-2.282-1.13-4.445c-.221-.878-.443-1.743-.657-2.6s-.443-1.728-.657-2.562c-.06-.221-.111-.443-.17-.657-.059-.243-.118-.48-.177-.716-.074-.3-.148-.575-.221-.864V394.9c-.081-.3-.155-.6-.229-.893-.148-.561-.288-1.115-.421-1.654-.207-.8-.406-1.58-.6-2.34-.082-.332-.17-.664-.251-.989-.14-.532-.274-1.048-.4-1.558-.089-.339-.17-.672-.251-1q-.52-2-.959-3.765c-.082-.31-.155-.613-.237-.908-.125-.51-.251-1-.369-1.469q-.122-.444-.222-.864c-.258-1-.494-1.919-.694-2.724-.059-.214-.111-.421-.163-.62-.133-.532-.258-1-.362-1.425-.044-.17-.081-.332-.125-.48-.044-.169-.082-.325-.118-.465-.022-.1-.052-.207-.074-.3-.037-.148-.074-.281-.1-.4-.015-.067-.029-.126-.044-.177l-.133-.524h56.712s1.868,6.438,4.858,16.82c.605,2.111,1.262,4.393,1.964,6.815C181.47,402.907,183.789,410.984,186.284,419.726Z",
    transform: "translate(-115.95 -372.354)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_25",
    "data-name": "Group 25",
    transform: "translate(12.306 13.285)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M145.318,428.1h-1.454q-3.234-13.39-6.269-26.824-.731-3.267-1.447-6.541c-.044-.207-.088-.406-.132-.613a.088.088,0,0,1,.169-.044c.022.066.037.133.059.2q.985,3.51,1.956,7.036Q141.888,414.669,145.318,428.1Z",
    transform: "translate(-136.012 -394.012)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M170.824,372.354l-2.5,12.529-2.053,10.278-3.492,17.513-.362,1.794-.6,2.99-.45,2.267H128.014c-.472-1.883-.945-3.729-1.4-5.538-.531-2.089-1.056-4.127-1.557-6.113-.111-.444-.229-.886-.34-1.322q-.576-2.282-1.13-4.445c-.221-.878-.443-1.743-.657-2.6s-.443-1.728-.657-2.562c-.06-.221-.111-.443-.17-.657-.059-.243-.118-.48-.177-.716-.074-.3-.148-.575-.221-.864V394.9c-.081-.3-.155-.6-.229-.893-.148-.561-.288-1.115-.421-1.654-.207-.8-.406-1.58-.6-2.34-.089-.34-.17-.664-.251-.989-.14-.532-.274-1.048-.4-1.558-.089-.339-.17-.672-.251-1q-.52-2-.959-3.765c-.082-.31-.155-.613-.237-.908-.125-.51-.251-1-.369-1.469q-.122-.444-.222-.864c-.258-1-.494-1.919-.694-2.724-.059-.214-.111-.421-.163-.62-.133-.532-.258-1-.362-1.425-.044-.17-.081-.332-.125-.48-.044-.169-.082-.325-.118-.465-.022-.1-.052-.207-.074-.3-.037-.148-.074-.281-.1-.4-.015-.067-.029-.126-.044-.177l-.133-.524Z",
    transform: "translate(-115.95 -372.354)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M154.372,372.318v.022c-.022.31-.236,3.691-.783,8.853-.155,1.507-.34,3.16-.554,4.932-.332,2.8-.745,5.884-1.255,9.148-.871,5.692-2.008,11.9-3.485,17.971-.524,2.186-1.1,4.349-1.713,6.468l-73.206.026c.864-11.156,1.654-21.246,2.281-29.2.878-11.193,1.44-18.2,1.44-18.2l66.406-.022Z",
    transform: "translate(-73.377 -372.318)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28",
    transform: "translate(7.715 4.998)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M196.891,382.194c-.081,2.622-.192,5.235-.362,7.841-.177,2.828-.436,5.648-.8,8.469-.007.1-.022.207-.037.31q-.52,3.965-1.189,7.907a27.911,27.911,0,0,1-1.816,7.362,7.2,7.2,0,0,1-1.713,2.311,5.059,5.059,0,0,1-2.341,1.211,2.759,2.759,0,0,1-.436.074c-.037.007-.081,0-.126.007a.159.159,0,0,1,.082.155c-.029.878-.007,1.771-.1,2.643-.007.037-.007.074-.015.11-.088.761-.229,1.514-.369,2.267h-1.255c.007-.015.007-.03.015-.045.221-.827.406-1.661.613-2.5s.5-1.683.7-2.547a.166.166,0,0,1,.059-.081,3.9,3.9,0,0,1-3.78-2.37,6.788,6.788,0,0,1-.059-3.441c.229-1.5.45-3,.679-4.5.428-2.754.982-5.479,1.47-8.218.074-.413.147-.834.221-1.248.982-5.575,2.008-11.149,3.241-16.672.044-.229.1-.458.148-.687.029-.155.28-.11.266.037-.037.369-.074.746-.118,1.115q-.321,3.179-.76,6.335c-.355,2.474-.6,4.962-.945,7.436-.118.842-.236,1.683-.362,2.525-.569,4.068-1.159,8.136-1.853,12.19-.325,1.883-1.5,5.257,1.211,5.84a2.765,2.765,0,0,0,1.838-.229,5.767,5.767,0,0,0,2.517-3.182,42.238,42.238,0,0,0,1.44-6.778q.664-3.721,1.181-7.45v-.007q.664-4.663,1.388-9.31.366-2.37.746-4.74.178-1.1.355-2.193C196.647,381.995,196.891,382.039,196.891,382.194Z",
    transform: "translate(-123.766 -380.465)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M99.455,402.45a36.894,36.894,0,0,0,9.031-1.215c1.361-.35,2.705-.786,4.04-1.223a10.514,10.514,0,0,0,3.644-1.829c2.053-1.771,3.009-4.56,3.9-7.034a67.227,67.227,0,0,0,2.367-8.543c.031-.143.24-.1.244.039a33.122,33.122,0,0,1-1.229,9.7c-.735,2.676-1.727,5.664-3.89,7.539-2.275,1.974-5.365,2.667-8.276,3.027a38.069,38.069,0,0,1-9.84-.136A.162.162,0,0,1,99.455,402.45Z",
    transform: "translate(-91.112 -381.26)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M89.226,382.693q-.243,6.146-.516,12.3-.631,14.332-1.381,28.663H85.955q.941-14.365,1.986-28.707.454-6.135.93-12.264A.178.178,0,0,1,89.226,382.693Z",
    transform: "translate(-85.955 -381.26)",
    fill: "#263238"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_70",
    "data-name": "Group 70"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69",
    "data-name": "Group 69"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_37",
    "data-name": "Group 37",
    transform: "translate(59.221 63.933)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M167.1,232.334c15.661,1.938,65.516,8.572,75.477,24.488,7.234,11.56-.724,21.759-11.3,19.647-8.731-1.743-52.46-21.581-63.389-29.108C157.482,240.194,151.715,230.43,167.1,232.334Z",
    transform: "translate(-153.852 -230.923)",
    fill: "#d3766a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    "data-name": "Group 36"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M192.681,265.4l22.027-31.033s-41.473-5.622-54.136-3.833c-14.252,2.013-10.106,8.86.756,17.178S192.681,265.4,192.681,265.4Z",
    transform: "translate(-151.445 -230.185)",
    fill: "#3c74c7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35",
    transform: "translate(36.256 4.611)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M228.95,237.73c-.929.955-7.945,10.519-9.425,12.63s-7.613,10.685-8.959,12.993a.094.094,0,0,0,.148.115c1.748-2,7.958-10.633,9.51-12.753s8.284-11.736,8.878-12.9C229.152,237.723,229.013,237.665,228.95,237.73Z",
    transform: "translate(-210.55 -237.703)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M198.215,258.529l-5.533,7.8s-20.494-9.373-31.351-17.691c-9.354-7.165-13.728-13.237-5.656-16.065Z",
    transform: "translate(-151.446 -231.107)",
    opacity: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39",
    "data-name": "Group 39",
    transform: "translate(9.752 64.723)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38",
    "data-name": "Group 38"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M167.737,343.19,70.8,348.554s8.3-80.219,43.771-114.068c4.384-4.183,14.646-3.654,21.443-.588,2.428,1.1,11.428,12.741,14.293,23.963C153.152,269.071,167.991,342.843,167.737,343.19Z",
    transform: "translate(-70.799 -231.473)",
    fill: "#4381de"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M133.229,233.338l-17.795,1.018a9.081,9.081,0,0,1,1.1-.693l14.771-.853C131.96,232.963,132.6,233.141,133.229,233.338Zm4.778,2.668-25.824,1.484c-.215.221-.423.442-.632.669l27.014-1.552C138.376,236.392,138.192,236.19,138.008,236.006Zm2.852,3.417-32.038,1.84c-.19.221-.368.442-.552.662l33.038-1.9C141.155,239.821,141.007,239.619,140.86,239.423Zm2.386,3.435-37.387,2.153c-.172.215-.331.436-.491.656l38.27-2.2C143.51,243.262,143.381,243.06,143.246,242.858Zm2.1,3.46-42.153,2.423c-.147.215-.294.435-.442.656l42.938-2.466C145.571,246.728,145.461,246.52,145.344,246.317Zm1.822,3.472-46.4,2.662-.4.662,47.1-2.711C147.362,250.194,147.264,249.992,147.166,249.789Zm1.546,3.49-50.164,2.883c-.129.215-.258.436-.38.656l50.784-2.92C148.877,253.69,148.792,253.488,148.712,253.279Zm1.227,3.5-53.446,3.073c-.117.215-.233.436-.35.656l53.986-3.1C150.074,257.2,150.012,256.99,149.939,256.782Zm.92,3.527-56.28,3.233c-.1.215-.215.436-.325.65l56.752-3.257C150.957,260.72,150.908,260.505,150.859,260.309Zm.8,3.533L92.8,267.222c-.1.221-.2.436-.307.656l59.3-3.411C151.748,264.253,151.705,264.045,151.656,263.842Zm.779,3.527-61.3,3.527c-.1.215-.19.436-.288.65l61.727-3.552C152.521,267.78,152.478,267.572,152.435,267.369Zm.761,3.539-63.635,3.656c-.086.215-.178.436-.27.65l64.034-3.68Zm.748,3.533-65.861,3.785c-.08.215-.166.436-.252.65l66.248-3.809C154.03,274.859,153.987,274.65,153.944,274.442Zm.742,3.533-68,3.907c-.08.215-.159.429-.239.65l68.37-3.932C154.772,278.392,154.729,278.184,154.686,277.975Zm.742,3.539-70.057,4.024c-.074.215-.153.429-.227.644l70.413-4.042Zm.736,3.533L84.12,289.182c-.067.221-.141.436-.215.65l72.388-4.159Zm.724,3.533-73.952,4.251c-.067.221-.135.436-.2.65l74.284-4.275C156.981,289,156.938,288.789,156.889,288.581Zm.73,3.533-75.8,4.361c-.067.215-.135.429-.2.644l76.124-4.374C157.7,292.531,157.661,292.323,157.619,292.114Zm.73,3.539-77.6,4.459q-.1.322-.184.644l77.909-4.478Zm.718,3.539L79.734,303.75c-.055.215-.117.429-.172.644l79.632-4.576Zm.724,3.533-81.013,4.656q-.092.322-.166.644l81.3-4.674C159.876,303.143,159.833,302.935,159.79,302.726Zm.718,3.533-82.65,4.754c-.049.215-.1.429-.159.644l82.933-4.766C160.594,306.683,160.551,306.468,160.508,306.259Zm.718,3.539-84.233,4.84c-.049.215-.1.429-.153.644l84.509-4.858C161.305,310.216,161.262,310.007,161.225,309.8Zm.712,3.533L76.17,318.264c-.049.215-.1.429-.141.644l86.03-4.95C162.017,313.749,161.974,313.54,161.937,313.332Zm.712,3.539-87.257,5.018c-.049.215-.092.429-.141.638l87.521-5.03C162.728,317.288,162.685,317.08,162.648,316.871Zm.705,3.539-88.7,5.091c-.043.215-.086.429-.123.644l88.95-5.11C163.44,320.828,163.4,320.619,163.354,320.411Zm.705,3.533L73.95,329.127c-.037.215-.08.429-.117.638l90.349-5.2C164.139,324.361,164.1,324.152,164.059,323.944Zm.705,3.533L73.293,332.74c-.037.215-.074.429-.11.638l91.7-5.269C164.844,327.9,164.8,327.692,164.765,327.477Zm.693,3.545-92.772,5.33c-.037.215-.074.429-.11.638l93-5.343C165.544,331.44,165.5,331.231,165.458,331.022Zm.693,3.533-94.041,5.41c-.031.215-.067.429-.1.638l94.262-5.416C166.231,334.979,166.194,334.77,166.151,334.556Zm.681,3.539-95.25,5.478c-.031.221-.061.436-.092.638l95.465-5.49C166.912,338.518,166.875,338.31,166.832,338.1Zm.669,3.539L71.11,347.173c-.031.233-.055.448-.08.638l96.581-5.551Q167.556,341.975,167.5,341.634Z",
    transform: "translate(-70.888 -231.99)",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_45",
    "data-name": "Group 45",
    transform: "translate(0.03 66.016)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M102.191,242.107c-9.735,12.42-53.3,65.722-46.531,90.859,3.545,13.167,25.856,3.941,31.865-5.017,4.959-7.393,22.27-61.59,24.709-74.635C114.555,240.893,111.756,229.9,102.191,242.107Z",
    transform: "translate(-54.95 -234.823)",
    fill: "#d3766a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_44",
    "data-name": "Group 44",
    transform: "translate(13.745)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M114.861,284.567l-37.5-6.462s25.433-33.237,35.671-40.9c11.522-8.626,13.413-.847,11.581,12.71S114.861,284.567,114.861,284.567Z",
    transform: "translate(-77.358 -233.58)",
    fill: "#4381de"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_43",
    "data-name": "Group 43",
    transform: "translate(6.323 23.397)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41",
    "data-name": "Group 41",
    transform: "translate(0 15.379)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40",
    "data-name": "Group 40"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M87.765,296.794c1.332.022,13.051,1.852,15.59,2.306s12.933,2.2,15.515,2.89a.094.094,0,0,1-.023.186c-2.652-.188-13.141-1.924-15.736-2.333s-14.151-2.476-15.39-2.878C87.617,296.931,87.675,296.793,87.765,296.794Z",
    transform: "translate(-87.665 -296.794)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_42",
    "data-name": "Group 42",
    transform: "translate(28.066)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M133.42,298.776c1.053.093,2.1.228,3.147.347l-.215.127q1.011-3.465,2.092-6.906t2.178-6.874l2.208-6.861c.733-2.289,1.483-4.569,2.143-6.887a65.217,65.217,0,0,1-1.5,7.074q-.911,3.5-1.994,6.946t-2.259,6.86c-.789,2.274-1.62,4.533-2.508,6.774l-.064.162-.151-.035C135.474,299.263,134.443,299.041,133.42,298.776Z",
    transform: "translate(-133.42 -271.722)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M148.743,282.074a20.376,20.376,0,0,1,1.366-2.858c.518-.913,1.043-1.8,1.662-2.687a9.342,9.342,0,0,1-1.127,2.987A11.445,11.445,0,0,1,148.743,282.074Z",
    transform: "translate(-139.344 -273.58)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_58",
    "data-name": "Group 58",
    transform: "translate(49.047)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47",
    "data-name": "Group 47",
    transform: "translate(8.866 47.411)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46",
    "data-name": "Group 46"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M167.778,237.04c-5.108,1.536-14.478-5.849-18.376-12.056-.264-.427.132-5.1.344-10.812.116-3.464.163-7.323-.049-10.848-.047-.724,22.431,4.044,22.431,4.044a56.279,56.279,0,0,0-1.324,13.663,7.907,7.907,0,0,0,.239,1.437c.012.066.036.145.047.237C171.7,225.427,172.715,235.552,167.778,237.04Z",
    transform: "translate(-149.314 -203.249)",
    fill: "#d3766a"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M169.449,222.966a13.311,13.311,0,0,0,2.26-.256c-.012-.093-.033-.168-.046-.239a7.534,7.534,0,0,1-.234-1.437,56.437,56.437,0,0,1,1.319-13.659s-18.244-3.872-21.825-4.111C151.85,207.3,156.392,223.46,169.449,222.966Z",
    transform: "translate(-149.936 -203.255)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_57",
    "data-name": "Group 57"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48",
    "data-name": "Group 48",
    transform: "translate(4.123 7.189)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M141.994,151.419c-1.967,7.972,3.407,30.4,9.259,35.147,8.484,6.882,21.76,6.862,27.452-3.2,5.518-9.749-2-38.854-8.482-43.105C160.681,134,144.9,139.644,141.994,151.419Z",
    transform: "translate(-141.581 -137.678)",
    fill: "#d3766a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_53",
    "data-name": "Group 53",
    transform: "translate(19.801 25.675)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_49",
    "data-name": "Group 49",
    transform: "translate(1.846 7.798)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M174.9,182.538c-.026-.054-.1.1-.08.163.441,1.49.7,3.271-.534,4.126-.038.026-.014.1.035.08C175.919,186.24,175.557,183.879,174.9,182.538Z",
    transform: "translate(-171.741 -181.3)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M171.555,180.547c-2.465.45-1.384,5.346.9,4.93C174.7,185.067,173.622,180.17,171.555,180.547Z",
    transform: "translate(-170.149 -180.526)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_50",
    "data-name": "Group 50",
    transform: "translate(14.369 4.544)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M190.568,178.4c0-.061.135.045.147.108.286,1.527.872,3.228,2.355,3.43.047.006.059.083.006.087C191.349,182.159,190.595,179.893,190.568,178.4Z",
    transform: "translate(-190.567 -176.443)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M191.572,175.295c2.4-.723,3.669,4.128,1.447,4.8C190.832,180.752,189.562,175.9,191.572,175.295Z",
    transform: "translate(-190.566 -175.222)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M168.169,173.9a19.386,19.386,0,0,0,2.059.007,3.323,3.323,0,0,0,2.1-.393,1.061,1.061,0,0,0,.27-1.266,2.629,2.629,0,0,0-2.406-1.145,3.861,3.861,0,0,0-2.657.827A1.131,1.131,0,0,0,168.169,173.9Z",
    transform: "translate(-167.14 -169.082)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M192.958,170.789a19.425,19.425,0,0,1-1.964.618,3.325,3.325,0,0,1-2.123.248,1.059,1.059,0,0,1-.634-1.129,2.629,2.629,0,0,1,1.957-1.806,3.863,3.863,0,0,1,2.784,0A1.132,1.132,0,0,1,192.958,170.789Z",
    transform: "translate(-175.29 -168.064)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M178.42,204.924c.442.275.912.684,1.473.608a4.1,4.1,0,0,0,1.546-.742.055.055,0,0,1,.083.064,2.092,2.092,0,0,1-1.744,1.248,1.654,1.654,0,0,1-1.489-1.078C178.246,204.941,178.355,204.884,178.42,204.924Z",
    transform: "translate(-171.447 -182.105)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_52",
    "data-name": "Group 52",
    transform: "translate(7.331)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_51",
    "data-name": "Group 51"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M179.458,188.318c3.519-1.257,6.6-1.843,6.595-2.016l0-.011c-.014-.055-.814-3.222-.814-3.222.474.12,2.865.618,2.7.015-1.416-4.985-2.99-10.528-5.452-15.189a.144.144,0,0,0-.269.1c1.171,4.845,3.187,9.45,4.441,14.3a9.288,9.288,0,0,0-2.6-.2c-.155.085.855,2.938.915,3.474a29.813,29.813,0,0,0-5.784,2.261C178.964,187.946,179.17,188.4,179.458,188.318Z",
    transform: "translate(-179.091 -167.814)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_55",
    "data-name": "Group 55",
    transform: "translate(0.351)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M142.869,170.609c1.378-.557,3.679-6.166,4.689-8.417,1.068-2.339-.516-12.721-.918-15.079a15.845,15.845,0,0,0-4.582,7.511C141.136,158.059,141.593,164.309,142.869,170.609Z",
    transform: "translate(-137.805 -134.137)",
    fill: "#263238",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_54",
    "data-name": "Group 54"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M173.59,154.283a7.559,7.559,0,0,1-6.275,3.842,7.706,7.706,0,0,1-6.707-3.367.06.06,0,0,0-.1.063,7.627,7.627,0,0,0,6.822,3.918,7.782,7.782,0,0,0,6.425-4.366A.094.094,0,0,0,173.59,154.283Z",
    transform: "translate(-145.121 -136.89)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M157.74,126.771c-4.275.938-7.751,4.089-8.746,7.323a8.475,8.475,0,0,0,.255,5.576c.026.072.177.026.156-.047a9.3,9.3,0,0,1,2.684-9.1,11.992,11.992,0,0,1,10.16-3.295,7.589,7.589,0,0,1,4.628,2.423c.114.139.416-.025.316-.171C165.5,127.034,161.61,125.922,157.74,126.771Z",
    transform: "translate(-140.536 -126.163)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M198.383,131.087a9.645,9.645,0,0,0-5.036-4.3c-2.955-1.113-5.887-.288-8.784.594a.064.064,0,0,0,.037.122c2.468-.742,5.015-1.35,7.561-.621a9.486,9.486,0,0,1,5.2,3.685,9.245,9.245,0,0,1-1.544,12.007,9.389,9.389,0,0,1-7.124,2.169c-.1-.012-.142.14-.039.155a9.444,9.444,0,0,0,9.733-13.812Z",
    transform: "translate(-154.408 -126.072)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M139.1,150.992s-5.557-6.9-3-12.009c1.449-2.893,7.928-3.793,7.928-3.793a11.779,11.779,0,0,1,6.441-6.321c5.135-2.259,12.12-.347,12.12-.347s4.54-3.9,9.84-2.083c7.39,2.53,8.5,12.835,2.423,17.381-4.269,3.193-11.459.251-11.459.251-.6.2-6.167,5.2-12,.5,0,0-3.209,4.179-7.143,2.435A5.706,5.706,0,0,1,139.1,150.992Z",
    transform: "translate(-135.431 -125.958)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_56",
    "data-name": "Group 56",
    transform: "translate(0 33.959)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M144.763,186.57s-5.661-6.935-8.845-4.863,1.454,12.39,5.459,13.551a3.975,3.975,0,0,0,5.152-2.527Z",
    transform: "translate(-134.86 -181.32)",
    fill: "#d3766a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M138.84,186.718a.054.054,0,0,0-.013.106c2.816.9,4.443,3.33,5.646,5.882a2.194,2.194,0,0,0-3.319-.354c-.067.056.009.163.085.14a2.444,2.444,0,0,1,2.746.651,11.835,11.835,0,0,1,1.447,2.075c.146.235.577.071.463-.2-.008-.02-.018-.042-.027-.062C145.679,191.464,142.607,186.79,138.84,186.718Z",
    transform: "translate(-136.379 -183.407)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63",
    "data-name": "Group 63",
    transform: "translate(0 87.563)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M65.442,380.527C54.559,379.506,52.1,365.5,58.073,360.734c14.008-11.174,35.68-18.318,51.619-21.225,5.129-.935,10.075,32.155,5.232,34.915C109.854,377.312,83.926,382.261,65.442,380.527Z",
    transform: "translate(-54.901 -296.071)",
    fill: "#d3766a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_62",
    "data-name": "Group 62",
    transform: "translate(45.663)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M170.333,323.853c-.012.041-.018.083-.03.125a.186.186,0,0,0-.015.063c-1.537,6.359-3.89,12.645-6.429,15.911-3.763,5.248-21.629,8.962-21.629,8.962l-12.888-32.847s8.252-3.145,8.683-9.435c0,0,.839-9.4,2.162-12.412,1.73-3.943,9.4-20.709,11.4-21.569s4.347,1.973,2.991,8.318-6.136,18.263-6.235,19.054a5.346,5.346,0,0,0,.058.8l.007.008c.138.326,2.665,10.457,6.131,12.771a3.918,3.918,0,0,0,2.66.333c2.943-2.558,3.209-6.987,3.487-9.2.454-3.614,1.022-14.927,6.494-15.63s2.9,12.279,3.439,20.39C170.861,313.137,171.588,318.6,170.333,323.853Z",
    transform: "translate(-129.343 -270.173)",
    fill: "#d3766a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_59",
    "data-name": "Group 59",
    transform: "translate(11.9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M148.744,309.061s-.074-15.806,1.8-18.511,10.622-20.662,12.623-21.523,4.347,1.976,2.993,8.323-6.139,18.257-6.239,19.053,2.23,14.517,2.062,15.848S148.744,309.061,148.744,309.061Z",
    transform: "translate(-148.743 -268.772)",
    fill: "#d3766a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M149.12,300.315c.07-1.726.223-3.445.38-5.167.1-.859.2-1.718.335-2.577.069-.429.143-.859.24-1.292a6.369,6.369,0,0,1,.185-.663c.049-.116.1-.249.155-.349l.15-.287c1.6-3.058,3.252-6.078,4.91-9.1,1.683-3.012,3.337-6.01,5.111-9a10.807,10.807,0,0,1,1.661-2.078,4.908,4.908,0,0,1,1.1-.805,2.2,2.2,0,0,1,1.4-.267,1.823,1.823,0,0,1,1.157.808,4,4,0,0,1,.531,1.229,9.467,9.467,0,0,1,.262,2.587,11.222,11.222,0,0,0-.494-2.515,3.723,3.723,0,0,0-.577-1.093,1.419,1.419,0,0,0-.948-.57,2.715,2.715,0,0,0-2.023,1.042,10.162,10.162,0,0,0-1.461,2.029c-1.6,3.024-3.259,6.076-4.922,9.094-1.681,3.014-3.362,6.028-5.1,9l-.163.279c-.05.09-.074.158-.117.237-.067.175-.134.374-.188.574-.112.4-.2.819-.293,1.237-.175.837-.315,1.686-.459,2.534C149.638,296.9,149.4,298.61,149.12,300.315Z",
    transform: "translate(-148.889 -268.706)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_60",
    "data-name": "Group 60",
    transform: "translate(13.645 0.941)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M152.722,312.352s-.012-17.324,1.859-20.03S165.2,271.66,167.2,270.8s4.347,1.976,2.993,8.322-6.139,18.258-6.239,19.054,2.23,14.517,2.063,15.847S152.722,312.352,152.722,312.352Z",
    transform: "translate(-152.026 -270.398)",
    fill: "#d3766a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M151.588,303.8c.21-2.1.511-4.2.847-6.286.185-1.042.381-2.083.624-3.121.122-.519.254-1.037.423-1.555a5.178,5.178,0,0,1,.32-.788l.385-.7q3.05-5.542,6.16-11.065l3.149-5.5.8-1.367a11.612,11.612,0,0,1,.895-1.366,6.322,6.322,0,0,1,1.186-1.192,2.75,2.75,0,0,1,1.681-.625,1.866,1.866,0,0,1,1.526,1.01,4.981,4.981,0,0,1,.556,1.584,14.619,14.619,0,0,1,.2,3.212,18.469,18.469,0,0,1-1.343,6.2,19.732,19.732,0,0,0,.9-6.2,14.932,14.932,0,0,0-.318-3.087,4.415,4.415,0,0,0-.537-1.371,1.2,1.2,0,0,0-1-.648,2.063,2.063,0,0,0-1.2.53,6.17,6.17,0,0,0-1.013,1.075,10.885,10.885,0,0,0-.812,1.3l-.774,1.379-3.1,5.521c-2.081,3.674-4.16,7.347-6.317,10.983l-.407.674a4.524,4.524,0,0,0-.3.667c-.179.478-.33.978-.472,1.481-.282,1.007-.521,2.033-.749,3.061C152.417,299.658,152.013,301.73,151.588,303.8Z",
    transform: "translate(-151.588 -270.24)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61",
    "data-name": "Group 61",
    transform: "translate(13.34 8.419)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M151.845,317.219s-.012-16.128,1.73-18.646S164.043,284.5,165.906,283.7s4.046,1.84,2.787,7.747S162.4,303.28,162.3,304.021s2.075,13.514,1.92,14.752S151.845,317.219,151.845,317.219Z",
    transform: "translate(-151.382 -282.868)",
    fill: "#d3766a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M151.091,311.3q.182-2.57.451-5.132c.179-1.708.361-3.417.635-5.121.074-.426.142-.851.24-1.278a4.77,4.77,0,0,1,.418-1.286,21.968,21.968,0,0,1,1.426-2.19c1.007-1.4,2.06-2.761,3.126-4.11q3.21-4.04,6.652-7.89.432-.481.885-.954c.158-.159.3-.31.494-.478a1.778,1.778,0,0,1,.733-.394,1.447,1.447,0,0,1,.9.068,2.067,2.067,0,0,1,.669.463,4.229,4.229,0,0,1,.791,1.2,8.633,8.633,0,0,1,.687,2.62,9.139,9.139,0,0,1-.116,2.683,25.324,25.324,0,0,1-3.8,9.689c-.513.731-1,1.384-1.452,2.112s-.9,1.45-1.318,2.182c-.048.086-.107.194-.133.248.02-.049-.006.093,0,.177,0,.2,0,.407.007.616.015.418.046.842.079,1.264.071.845.174,1.69.3,2.531a87,87,0,0,0,2.5,9.942c.443,1.66.869,3.327,1.235,5.007a23,23,0,0,1,.681,5.1,25.381,25.381,0,0,0-.914-5.048c-.431-1.658-.92-3.3-1.427-4.939l-1.524-4.917a39.044,39.044,0,0,1-1.237-5.034c-.15-.853-.275-1.71-.369-2.573-.045-.432-.085-.865-.1-1.3-.01-.22-.017-.44-.012-.671a1.469,1.469,0,0,1,.063-.461c.064-.14.11-.22.165-.323.424-.765.866-1.5,1.325-2.235s.98-1.464,1.447-2.141a24.456,24.456,0,0,0,3.589-9.374,8.813,8.813,0,0,0,.117-2.442,7.759,7.759,0,0,0-.591-2.345,3.384,3.384,0,0,0-.608-.948.786.786,0,0,0-.739-.306,2.022,2.022,0,0,0-.821.628c-.293.3-.585.612-.873.926-2.3,2.523-4.511,5.154-6.7,7.784-1.093,1.318-2.175,2.647-3.2,4.009a21.609,21.609,0,0,0-1.434,2.087,4.308,4.308,0,0,0-.4,1.145c-.106.406-.185.827-.269,1.245C152.006,304.5,151.566,307.906,151.091,311.3Z",
    transform: "translate(-151.091 -282.432)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M108.354,341.977c-1.66.5-3.319.989-4.962,1.534-1.651.516-3.291,1.06-4.926,1.621-3.264,1.134-6.512,2.309-9.72,3.582-3.222,1.24-6.384,2.625-9.529,4.048l-2.35,1.091-2.316,1.162c-1.575.721-3.057,1.613-4.614,2.382a82.15,82.15,0,0,1,8.971-5.272c3.092-1.583,6.268-3,9.5-4.267s6.512-2.419,9.842-3.4c1.668-.482,3.337-.954,5.018-1.381C104.958,342.679,106.645,342.275,108.354,341.977Z",
    transform: "translate(-60.714 -297.032)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_68",
    "data-name": "Group 68",
    transform: "translate(29.379 71.906)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M253.737,280.26c10.6-2.67,6.651-16.982.387-21.348-14.7-10.246-36.278-12.475-52.371-14.346-5.179-.6-8.488,29.239-3.476,31.68C203.522,278.8,232.231,285.678,253.737,280.26Z",
    transform: "translate(-138.749 -243.714)",
    fill: "#d3766a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_67",
    "data-name": "Group 67",
    transform: "translate(0 0.303)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M171.939,277.975c5.935-2.544,12.975-17.334,12.975-17.334l-8.846-15.435s-18.523-2.608-30.946-1.014c-3.436.441-35.487,7.393-36.7,9.147-1.235,1.794.989,4.67,7.479,4.714s19.155-2.056,19.949-1.983a5.322,5.322,0,0,1,.764.228l.007.007c.288.206,7.266,8.28,10.651,10.71,2.054,1.474,6.022,4.721,9.844,6.16C164.375,275.906,170.975,278.665,171.939,277.975Z",
    transform: "translate(-104.847 -243.677)",
    fill: "#d3766a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_64",
    "data-name": "Group 64",
    transform: "translate(0 4.524)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M145.65,254.673s-15.418-3.478-18.463-2.235-22.465,5.919-23.738,7.688.993,4.67,7.482,4.717,19.152-2.06,19.95-1.986,13.7,5.306,15.031,5.429S145.65,254.673,145.65,254.673Z",
    transform: "translate(-102.917 -251.484)",
    fill: "#d3766a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M137.123,251.052l-5.158.581c-.858.1-1.718.188-2.571.3a12.447,12.447,0,0,0-2.474.486c-3.3,1.106-6.607,2.078-9.924,3.071-3.314.97-6.66,1.921-9.97,2.832a10.335,10.335,0,0,0-2.306.986,2.749,2.749,0,0,0-1.472,1.75,1.4,1.4,0,0,0,.344,1.053,3.677,3.677,0,0,0,.943.8,11.179,11.179,0,0,0,2.356,1.03,9.49,9.49,0,0,1-2.478-.817,4.009,4.009,0,0,1-1.087-.789,1.808,1.808,0,0,1-.529-1.313,2.233,2.233,0,0,1,.575-1.305,4.933,4.933,0,0,1,1.031-.9,10.97,10.97,0,0,1,2.4-1.171c3.313-1.085,6.616-2.049,9.936-3.04,3.317-.969,6.651-1.922,9.967-2.855a6.424,6.424,0,0,1,.666-.169c.221-.033.443-.072.66-.094.437-.054.87-.092,1.3-.129q1.3-.108,2.6-.174C133.661,251.126,135.391,251.053,137.123,251.052Z",
    transform: "translate(-102.796 -251.052)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_65",
    "data-name": "Group 65",
    transform: "translate(0.357 6.524)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M148,259.315s-16.915-3.745-19.96-2.5-22.465,5.919-23.738,7.688.992,4.67,7.481,4.716,19.152-2.06,19.95-1.986,13.7,5.306,15.03,5.429S148,259.315,148,259.315Z",
    transform: "translate(-103.603 -255.182)",
    fill: "#d3766a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M139.895,254.313l-6.3.919c-1.049.152-2.1.311-3.137.491-.52.091-1.039.188-1.549.3a11.343,11.343,0,0,0-1.491.432c-4.036,1.336-8.091,2.578-12.147,3.826l-6.09,1.846c-1,.32-2.065.578-2.978.967a6.365,6.365,0,0,0-1.287.747,2.2,2.2,0,0,0-.816,1.055,1.153,1.153,0,0,0,.37,1.13,4.317,4.317,0,0,0,1.217.834,14.6,14.6,0,0,0,2.956.99,19.728,19.728,0,0,0,6.285.464,18.484,18.484,0,0,1-6.378-.03,14.443,14.443,0,0,1-3.108-.9,4.917,4.917,0,0,1-1.427-.907,2.162,2.162,0,0,1-.526-.763,1.665,1.665,0,0,1-.069-.98,2.878,2.878,0,0,1,1.016-1.48,6.543,6.543,0,0,1,1.436-.885,13.171,13.171,0,0,1,1.535-.572l1.516-.492L115,259.4q6.087-1.861,12.195-3.647a11.8,11.8,0,0,1,1.582-.389c.531-.092,1.059-.169,1.588-.238,1.057-.138,2.114-.254,3.171-.363C135.656,254.588,137.772,254.41,139.895,254.313Z",
    transform: "translate(-103.378 -254.313)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_66",
    "data-name": "Group 66",
    transform: "translate(7.949 8.879)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M153,260.15s-15.449.182-18.283,1.34-16.295,3.521-17.479,5.167.924,4.348,6.965,4.391,13.21.072,13.953.141,12.451,1.271,13.694,1.386S153,260.15,153,260.15Z",
    transform: "translate(-116.208 -258.924)",
    fill: "#d3766a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M148.419,258.152l-10.772,1.418c-.9.115-1.8.226-2.685.356-.848.159-1.728.428-2.588.68-1.727.52-3.445,1.085-5.156,1.668s-3.421,1.167-5.113,1.794c-.847.312-1.689.632-2.522.97a20.4,20.4,0,0,0-2.4,1.107c-.347.205-.558.451-.558.7a1.363,1.363,0,0,0,.447.881,6.193,6.193,0,0,0,2.113,1.346,7.888,7.888,0,0,0,2.489.588c.879.053,1.794.078,2.694.108q5.422.16,10.854.241c.915.01,1.786.031,2.726.014.941.058,1.823.169,2.728.274l5.394.655a4.838,4.838,0,0,1,1.394.313,10.456,10.456,0,0,1,1.257.612c.8.451,1.561.951,2.319,1.449,1.513,1,3.012,2,4.558,2.935a42.658,42.658,0,0,0,9.859,4.439,40.63,40.63,0,0,1-10.048-4.112c-1.589-.881-3.123-1.857-4.648-2.829-.764-.482-1.529-.964-2.313-1.385a9.866,9.866,0,0,0-1.194-.554,4.108,4.108,0,0,0-1.253-.251l-5.4-.529c-.9-.079-1.813-.179-2.679-.229-.869.026-1.81.01-2.705.008q-5.436-.044-10.869-.154c-.91-.023-1.806-.039-2.734-.088a8.619,8.619,0,0,1-2.77-.671,7.035,7.035,0,0,1-2.414-1.583,2.176,2.176,0,0,1-.669-1.516,1.468,1.468,0,0,1,.347-.871,2.385,2.385,0,0,1,.634-.522,20.882,20.882,0,0,1,2.535-1.149c.848-.336,1.7-.651,2.555-.959,1.711-.61,3.426-1.2,5.158-1.745s3.468-1.067,5.22-1.547a27.363,27.363,0,0,1,2.68-.632c.91-.109,1.806-.2,2.709-.288C141.2,258.756,144.807,258.429,148.419,258.152Z",
    transform: "translate(-115.755 -258.152)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M228.152,253.075a62.715,62.715,0,0,0-9-2.88q-4.574-1.183-9.224-2.055c-6.184-1.173-12.421-2.257-18.661-2.94-6.268-.636-12.564-1.106-18.857-1.31-1.573-.042-3.148-.081-4.719-.043a34.2,34.2,0,0,0-4.683.341c-3.107.521-6.212,1.109-9.329,1.619,3.076-.715,6.157-1.389,9.249-2.064a33.829,33.829,0,0,1,4.743-.478c1.584-.081,3.168-.084,4.751-.084,3.166,0,6.325.179,9.481.364s6.306.441,9.456.739c1.581.14,3.154.4,4.713.628s3.123.488,4.683.75c3.116.536,6.229,1.1,9.315,1.787,3.09.673,6.164,1.43,9.2,2.313A56.339,56.339,0,0,1,228.152,253.075Z",
    transform: "translate(-122.467 -243.183)",
    fill: "#263238"
  }))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1414);
export default __webpack_public_path__ + "static/media/Group 1414.ea7ddc35decc8ce320c0a9cbc70c3b7e.svg";
export { ForwardRef as ReactComponent };